const SDK_VERSION = '7.82.0';

export { SDK_VERSION };
//# sourceMappingURL=version.js.map
